import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
// import * as dayjs from 'dayjs';
import { getCityList, 
  // getOtgList, 
  getStreetList } from '../Axios/searchoff';
import Table from 'react-bootstrap/Table';
import { ToastContainer } from "react-toastify";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationLoe from './PaginationLoe';
import { defaultOptions, filterOption, selectOptions } from '../utils/search';
import { formatUTC } from '../utils/utils';
import dayjs from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const SearchGrafikPlanned = ({getPodiys}) => {
  
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedStreet, setSelectedStreet] = useState(null);
  const [selectedOtg, 
    // setSelectedOtg
  ] = useState(null);
  const [selectedFrom, setSelectedFrom] = useState('');
  const [selectedTo, setSelectedTo] = useState('');

  const [cityOptions, setCityOptions] = useState([]);
  // const [otgOptions, setOtgOptions] = useState([]);
  const [streetOptions, setStreetOptions] = useState([]);

  const [podiysList, setPodiysList] = useState([]);
  const [border, setBorder] = useState({otg: '#C4CBD2', city: '#C4CBD2', street: '#C4CBD2'});
  const [color, setColor] = useState({otg:'hsl(0, 0%, 50%)', city: 'hsl(0, 0%, 50%)', street: 'hsl(0, 0%, 50%)'});

  const formRef = useRef(null);
  const citySelect = useRef(null);
  const streetSelect = useRef(null);
  // const otgSelect = useRef(null);

  const tableOff = useRef(null);

  const dateFromRef = useRef(null);
  const dateToRef = useRef(null);

  const [page, setPage] = useState(1);
  const [totalItems, setTotal] = useState(1);
  
  const [noOff, setNoOff] = useState('');

  const formatFrom = dayjs(selectedFrom).format('YYYY-MM-DDTHH:mm:ssZ[Z]');
  // додати при відправці 1 день для пошуку по дню включно
  const formatTo = dayjs(selectedTo).add(1, "day").format('YYYY-MM-DDTHH:mm:ssZ[Z]');

 // встановелння періода для пошуку за замовчуванням поточний день + 5 днів
  const minDate = dayjs().format("YYYY-MM-DD");
  const maxDate = dayjs().add(5, "day").format("YYYY-MM-DD");

  useEffect(()=>{
    // при першому завантаженні сторінки
    selectOptions(getCityList, setCityOptions); // витягуємо перелік всіх міст
    // selectOptions(getOtgList, setOtgOptions); // витягуємо перелік всіх отг

  },[]);


  useEffect(() => {
    // встановелння періода для пошуку при першому завантажені сторінки
    setSelectedFrom(minDate);
    setSelectedTo(maxDate)
  }, [minDate, maxDate]);

  function handleFromChange(date){
    setSelectedFrom(date);
    // якщо взяти період більший від вибраної кінцевої дати, то виставити кінцеву дату в макс значення
    if(dayjs(selectedTo).diff(date) < 0){
      setSelectedTo(maxDate);
    }
  }

  useEffect(()=>{
    if(selectedOtg !== null){
      selectOptions(getCityList, setCityOptions, selectedOtg.value);
    }
    if(selectedCity !== null){
      selectOptions(getStreetList, setStreetOptions, selectedCity.value);
    }
  },[selectedOtg, selectedCity])
  
  const handleChangePage = (currentPage)=> {
    formRef.current.scrollIntoView({behavior: 'smooth'})
    setPage(currentPage);
    getPodiys(formatFrom, formatTo, selectedOtg?.value || '', selectedCity?.value || '', selectedStreet?.value || '', currentPage).then(response=>{
      const data = response['hydra:member'];
      setTotal(response['hydra:totalItems'])
      setPodiysList(data);
    })
  }

  function handleSubmit(e) {
    e.preventDefault();
    setPage(1);

    // відправка запиту в разі якщо дані заповнені всі поля
    if (selectedStreet !== null && selectedCity !== null && selectedFrom !== '' && selectedTo !== '') {
      getPodiys(formatFrom, formatTo, selectedOtg?.value || '', selectedCity?.value || '', selectedStreet?.value || '', 1).then(response=>{
        const data = response['hydra:member'];
        setTotal(response['hydra:totalItems']);
        setPodiysList(data);
        if(data.length === 0) {
          toast.error('Вимкнень не знайдено 💡', {
            position: toast.POSITION.BOTTOM_LEFT
         });
         setNoOff('За обраним Вами періодом та населеним пунктом/вулицею відключень не зафіксовано.');
         clearData();
        }
      }).catch((err)=> {
        toast.error(`Помилка обробки даних ${err.message}`, {
            position: toast.POSITION.BOTTOM_LEFT
        });
        clearData();
      })
    }

    // відстеження незаповнених даних -- всі поля пусті

    if (selectedStreet === null && selectedCity === null && selectedFrom === '' && selectedTo === '') {
      setBorder({street:'#e74c3c', city: '#e74c3c', dateTo: "#e74c3c", dateFrom: "#e74c3c"});
      setColor({street:'#e74c3c', city:'#e74c3c'});
      setTimeout(() => {
        setBorder({street:'#C4CBD2', city:'#C4CBD2', dateTo: "#C4CBD2", dateFrom: "#C4CBD2"});
        setColor({street:'hsl(0, 0%, 50%)', city:'hsl(0, 0%, 50%)'});
      }, 4000);
      setNoOff('');
      setPodiysList([]);
    }

    // відстеження незаповнених даних -- незаповнений період
    if ((selectedStreet !== null || selectedCity !== null) && (selectedFrom === '' || selectedTo === '')) {
      setBorder({street:'#C4CBD2', city: '#C4CBD2', dateTo: "#e74c3c", dateFrom: "#e74c3c"});
      setTimeout(() => {
        setBorder({street:'#C4CBD2', city:'#C4CBD2', dateTo: "#C4CBD2", dateFrom: "#C4CBD2"});
      }, 4000);
      setNoOff('');
      setPodiysList([]);
    }

    // відстеження незаповнених даних -- незаповнений населений пункт/вулиця
    if ((selectedFrom !== '' || selectedTo !== '') && (selectedStreet === null && selectedCity === null)) {
      setBorder({street:'#e74c3c', city: '#e74c3c', dateTo: "#C4CBD2", dateFrom: "#C4CBD2"});
      setColor({street:'#e74c3c', city:'#e74c3c'});
      setTimeout(() => {
        setBorder({street:'#C4CBD2', city:'#C4CBD2', dateTo: "#C4CBD2", dateFrom: "#C4CBD2"});
        setColor({street:'hsl(0, 0%, 50%)', city:'hsl(0, 0%, 50%)'});
      }, 4000);
      setNoOff('');
      setPodiysList([]);
    }

    // відстеження незаповнених даних -- незаповнений вулиця
    if ((selectedFrom !== '' || selectedTo !== '') && (selectedStreet === null && selectedCity !== null)) {
      setBorder({street:'#e74c3c'});
      setColor({street:'#e74c3c'});
      setTimeout(() => {
        setBorder({street:'#C4CBD2'});
        setColor({street:'hsl(0, 0%, 50%)'});
      }, 4000);
      setNoOff('');
      setPodiysList([]);
    }
  }
  
  function clearData(){
    // otgSelect.current.clearValue();
    citySelect.current.clearValue(); 
    streetSelect.current.clearValue();

    if(selectedCity !== null){
      selectOptions(getCityList, setCityOptions);
    }
  }

  const dateOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };
  
  const timeOptions = {
    timeZone: 'UTC',
    hour: 'numeric', 
    minute: 'numeric',
  };

  return (
      <div className="search-off">
        <form action="submit" onSubmit={handleSubmit} ref={formRef} >
          {/* <label htmlFor="otg">Об'єднана територіальна громада</label>
          <Select
            cacheOptions
            ref={otgSelect} 
            id={'otg'}
            placeholder={'Оберіть ОТГ'} 
            onChange={setSelectedOtg} 
            options={otgOptions}
            noOptionsMessage={() => 'Адреси не знайдено'} 
            loadingMessage={() => 'Завантаження...'}
            onSelectResetsInput = {false}
            onMenuOpen={clearData}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                border: `1px solid ${border.otg}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: 'white',
                paddingLeft: '10px',
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                color: color.otg
              })
            }}
            onFocus={()=>{setBorder({...border, otg: '#C4CBD2'}); setColor({...color, otg: 'hsl(0, 0%, 50%)'})}}
            /> */}
         <label htmlFor="city">Населений пункт*</label>
          <Select
            cacheOptions
            ref={citySelect} 
            id={'city'}
            placeholder={'Оберіть ваш населений пункт'} 
            onChange={setSelectedCity} 
            defaultOptions={defaultOptions}
            options={cityOptions}
            noOptionsMessage={() => 'Адреси не знайдено'} 
            loadingMessage={() => 'Завантаження...'}
            onSelectResetsInput = {false}
            filterOption={filterOption}
            onMenuOpen={() => {
              citySelect.current.clearValue(); 
              streetSelect.current.clearValue();
            }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: `1px solid ${border.city}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: state.isDisabled ? 'hsl(0, 0%, 95%)' : 'white',
                borderColor: state.isDisabled ? 'hsl(0, 0%, 90%)' : `1px solid ${border.city}`,
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                paddingLeft: '10px',
                opacity: state.isDisabled ? 0.7 : 1
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? 'hsl(0, 0%, 50%);' : color.city
              })
            }}
            onFocus={()=>{setBorder({...border, city: '#C4CBD2'}); setColor({...color, city: 'hsl(0, 0%, 50%)'})}}
            />
         <label htmlFor="street">Вулиця*</label>
         <Select 
            cacheOptions
            ref={streetSelect}
            id={'street'}
            placeholder={(selectedCity === null) ? 'Заповніть поле "Населений пункт"' : "Оберіть вашу вулицю"} 
            onChange={setSelectedStreet} 
            options={streetOptions}
            noOptionsMessage={() => 'Адреси не знайдено'} 
            loadingMessage={() => 'Завантаження...'}
            isDisabled={selectedCity === null}
            onMenuOpen={()=>streetSelect.current.clearValue()}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: `1px solid ${border.street}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: state.isDisabled ? 'hsl(0, 0%, 95%)' : 'white',
                borderColor: state.isDisabled ? 'hsl(0, 0%, 90%)' : `1px solid ${border.street}`,
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                paddingLeft: '10px',
                opacity: state.isDisabled ? 0.9 : 1
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? 'hsl(0, 0%, 50%);' : color.street
              })
            }}
            onFocus={()=>{setBorder({...border, street: '#C4CBD2'}); setColor({...color, street: 'hsl(0, 0%, 50%)'})}}
          />
          <div className="period-inner">
            <div className="period-inner__field">
             <label htmlFor="from">Період з</label>
             <div className="picker-inner">
              <DatePicker
                  selected={selectedFrom ? new Date(selectedFrom) : null}
                  onChange={(date)=> {handleFromChange(date)}}
                  minDate={minDate}
                  maxDate={maxDate}
                  locale="uk"
                  dateFormat="dd.MM.yyyy"
                  placeholderText="Оберіть дату"
                  className={"date-input"}
                  ref={dateFromRef}
              />
                <i class="fa fa-calendar" onClick={() => dateFromRef.current.setOpen(true)}></i>
             </div>
            </div>
            <div className="period-inner__field">
             <label htmlFor="to">Період по</label>
             <div className="picker-inner">
              <DatePicker
                  selected={selectedTo ? new Date(selectedTo) : null}
                  onChange={(date)=> {setSelectedTo(date)}}
                  minDate={selectedFrom}
                  maxDate={maxDate}
                  locale="uk"
                  dateFormat="dd.MM.yyyy"
                  placeholderText="Оберіть дату"
                  className={"date-input"}
                  ref={dateToRef}
              />
              <i class="fa fa-calendar" onClick={() => dateToRef.current.setOpen(true)}></i>
            </div>
            </div>
          </div>           
         <button className='power-btn'>Вибрати</button>
         <ToastContainer/> 
       </form>
        {podiysList.length > 0 ?
        <>
          <div className="arrow-inner">	
            <div className="scroll-left" onClick={()=>{tableOff.current.scrollLeft -= 120;}}>&#8592;</div> 
            <div className="scroll-right" onClick={()=>{tableOff.current.scrollLeft += 120;}}>&#8594;</div>
          </div>
        <div className="search-off__table" ref={tableOff}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ОТГ</th>
              <th>Населений пункт</th>
              <th>Вулиця</th>
              <th>Будинок</th>
              <th style={{minWidth: '195px'}}>Тип відключення</th>
              <th style={{maxWidth: '160px'}}>Час відключення</th>
              <th style={{maxWidth: '160px'}}>Очікуваний час включення</th>
            </tr>
          </thead>
          <tbody>
            {podiysList.map(podiy=>{
              return <tr key={podiy['@id']}>
                        <td>{podiy.otg.name}</td>
                        <td style={{textAlign: 'center'}}>{podiy.city.name}</td>
                        <td>{podiy.street.name}</td>
                        <td className='buildings-td' style={{maxWidth: '350px', wordWrap: 'break-word'}}>{podiy.buildingNames}</td>
                        <td style={{textAlign: 'center'}}>Планове відключення</td>
                        <td style={{textAlign: 'center', minWidth: '150px'}}>{formatUTC(podiy.dateEvent, dateOptions, timeOptions)}</td>
                        <td style={{textAlign: 'center', minWidth: '150px'}}>{formatUTC(podiy.datePlanIn, dateOptions, timeOptions)}</td>
                    </tr>
            })}
          </tbody>
          </Table>
          </div>
               <PaginationLoe
                changePage={handleChangePage}
                currentPage={page}
                total={totalItems}
                limit={30}
           /> 
        </> 
        : <p className="off-msg"><strong>{noOff}</strong></p>
      }
      {(podiysList.length > 0 || noOff.length > 0) && 
          <div className="date-synk grafics">
            — Інформацію сформовано станом на {dayjs(new Date()).format('DD.MM.YYYY HH:mm')}
          </div>
      }
      </div>
  )
}

export default SearchGrafikPlanned